export default __webpack_public_path__ + "static/media/instagram.a86d6524.png";